interface props {
  size: number;
  value: number;
  max: number;
  strokeWidth: number;
  stroke: string;
}

export default function Progress({
  size,
  value = 0,
  max,
  strokeWidth,
  stroke,
}: props) {
  const radius = (size - strokeWidth) / 2;
  const viewBox = `0 0 ${size} ${size}`;
  const dashArray = radius * Math.PI * 2;
  const dashOffset = dashArray - (dashArray * value) / max;

  return (
    <svg width={size} height={size} viewBox={viewBox}>
      <circle
        fill={"none"}
        stroke={"#374052"}
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
      />
      <circle
        fill={"none"}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray={dashArray}
        strokeDashoffset={dashOffset}
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
      <text
        x="45%"
        y="50%"
        dy="0.8rem"
        textAnchor="middle"
        fill={"white"}
        style={{
          fontSize: "2.5rem",
          fontWeight: "bold",
        }}
      >
        {`${value}`}
      </text>
      {value < 10 ? (
        <text
          x="60%"
          y="50%"
          dy="0.8rem"
          textAnchor="middle"
          fill={"white"}
          style={{
            fontSize: "1.5rem",
            fontWeight: "bold",
          }}
        >
          {`%`}
        </text>
      ) : (
        <text
          x="67%"
          y="50%"
          dy="0.8rem"
          textAnchor="middle"
          fill={"white"}
          style={{
            fontSize: "1.5rem",
            fontWeight: "bold",
          }}
        >
          {`%`}
        </text>
      )}
    </svg>
  );
}
